// Single source of truth for the product name across the landing site.
// i18n copy reads it via the `{{brand}}` interpolation variable (wired in
// lib/i18n.ts), and components/content import the constants directly — so a
// future rename touches this file plus the static tags in index.html only.

export const BRAND_NAME = "Mavori";

// Wordmark split: the trailing segment renders in the primary color when used.
export const BRAND_WORDMARK_BASE = "Mavori";
export const BRAND_WORDMARK_ACCENT = "";

export const SOCIAL_LINKS = {
  x: "https://x.com/MavoriAI",
  discord: "https://mavori.ai/discord",
  telegram: "https://mavori.ai/telegram",
  youtube: "https://youtube.com/@MavoriAI",
  tiktok: "https://tiktok.com/@mavoriai",
} as const;

// Public contact inbox — shown in the footer as both an icon and a text button.
export const CONTACT_EMAIL = "hello@mavori.ai";
